<template>
  <header-block title="Unprocessed Documents"></header-block>
  <CustomerLoadWait :customer="customer" />
  
    <div v-if="documents">
      <div class="documents-container">
        <v-row v-if="documents.length === 0" class="mt-4">
          <v-col>
            <p class="text-center">No unprocessed documents found.</p>
          </v-col>
        </v-row>
        
        <SwipeActionsContainer
          :items="documents"
          :backgroundColor="'white'"
          :mailStyleSwipe="false"
          :actions="[
            {
              icon: 'mdi-delete',
              type: 'delete',
              color: 'white',
              backgroundColor: 'var(--background-color-alt2)'
            },
            {
              icon: 'mdi-pencil',
              type: 'edit',
              color: 'grey',
              backgroundColor: 'var(--background-color-alt)'
            }
          ]"
          @content-click="openDocument"
          @action-click="handleActionClick"
        >
          <template #default="{ item }">
            <div class="document-content">
              <div class="d-flex align-center">
                <v-icon class="docIcon" icon="mdi-file-document-outline"></v-icon>
                <div class="flex-grow-1">
                  <!-- <div class="docCol">{{ d.name.length > 10 ? d.name.substring(0, 30) + '...' : d.name }}</div> -->
                  <div class="docCol">{{ item.name }}</div>
                  <div class="doc-date">{{ item.createDateTimeString }}</div>
                </div>
                <v-icon size="small" color="grey">mdi-chevron-right</v-icon>
              </div>
            </div>
          </template>
        </SwipeActionsContainer>
      </div>
    </div>

    <!-- Delete Confirmation Dialog -->
    <MGDialog v-model="showDeleteDialog" max-width="400" title="Delete Document">
      <template #content>
        <p>Are you sure you want to delete this document?</p>
      </template>
      <template #actions>
        <MGButton :fullWidth="true" @click="deleteDocument" text="Delete" />
        <MGButton :stacked="true" :fullWidth="true" @click="showDeleteDialog = false" :outline="true" text="Cancel" />
      </template>
    </MGDialog>

    <!-- Rename Dialog -->
    <MGDialog v-model="showRenameDialog" max-width="400" title="Rename Document">
      <template #content>
        <v-text-field v-model="documentToRename.name" label="New Name" />
      </template>
      <template #actions>
        <MGButton :fullWidth="true" @click="renameDocument" text="Rename" />
        <MGButton :stacked="true" :fullWidth="true" @click="showRenameDialog = false" :outline="true" text="Cancel" />
      </template>
    </MGDialog>
</template>

<script>
import Services from '../mixins/Services';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import SwipeActionsContainer from './elements/SwipeActionsContainer.vue';
import MGButton from './elements/MGButton.vue';
import MGDialog from './elements/MGDialog.vue';

export default {
  name: 'UnprocessedDocumentsPage',
  mixins: [Services],
  components: {
    CustomerLoadWait,
    HeaderBlock,
    SwipeActionsContainer,
    MGButton,
    MGDialog
  },
  data() {
    return {
      processingDocument: null,
      showDeleteDialog: false,
      documentToDelete: null,
      showRenameDialog: false,
      documentToRename: null
    }
  },
  methods: {
    onLoad: async function() {
      this._getCustomer();
      // Get all documents and filter for unprocessed ones
      this._getDocuments(() => {
        // Filter where processedOk is false
        this.documents = this.documents.filter(doc => !doc.processedOk);
        console.log(this.documents, 'documents');
      });
    },

    openDocument({ item }) {
      // Open document in a new tab/window
      console.log(item, 'open document');
      if (item.url) {
        window.open(item.url, '_blank');
      }
    },

    handleActionClick({ item, action }) {
      switch (action.type) {
        case 'edit':
          this.openRenameDialog({ item });
          break;
        case 'delete':
          this.confirmDelete({ item });
          break;
      }
    },

    confirmDelete({ item }) {
      this.documentToDelete = item;
      this.showDeleteDialog = true;
    },

    openRenameDialog({ item }) {
      this.documentToRename = item;
      this.showRenameDialog = true;
    },

    deleteDocument() {
      if (this.documentToDelete) {
        this._deleteDocument(this.documentToDelete.id, () => {
          // Remove the document from the list after successful deletion
          this.documents = this.documents.filter(d => d.id !== this.documentToDelete.id);
          this.showDeleteDialog = false;
          this.documentToDelete = null;
        });
      }
    },

    renameDocument() {
      if (this.documentToRename) {
        console.log(this.documentToRename, 'document to rename');
        this._updateDocument(this.documentToRename, () => {
          this._getDocuments(() => {
            // Filter where processedOk is false
            this.documents = this.documents.filter(doc => !doc.processedOk);
          }, true);
          // Update the document name in the list immediately
          const docIndex = this.documents.findIndex(d => d.id === this.documentToRename.id);
          if (docIndex !== -1) {
            this.documents[docIndex].name = this.documentToRename.name;
          }
          this.showRenameDialog = false;
        });
      }
    }
  },
  mounted() {
    this.onLoad();
  }
}
</script>

<style scoped>
.documents-container {
  margin-left: -30px;
  margin-right: -30px;
  margin-top: -20px;
  margin-bottom: -20px;
  padding: 0;
  width: calc(100% + 60px);
}

.docsPanel {
  background: transparent;
}

.document-content {
  padding: 15px 30px;
  position: relative;
  min-height: 72px;
  cursor: pointer;
  user-select: none;
  width: 100%;
}

.docIcon {
  color: var(--grey-text);
  margin-right: 16px;
}

.docCol {
  font-size: 14px;
  color: var(--text-color);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
  width: 100%;
  display: block;
}

.flex-grow-1 {
  min-width: 0;
  flex: 1 1 auto;
}

.doc-date {
  font-size: 12px;
  color: var(--grey-text);
}

.action-btn {
  width: 40px !important;
  height: 40px !important;
  border-radius: 50%;
}

/* Make v-card-actions fill full width */
:deep(.v-card-actions) {
	width: 100% !important;
	padding: 16px !important;
}

:deep(.v-card-actions .d-flex) {
	width: 100% !important;
}

/* Make buttons in dialog full width */
:deep(.v-dialog .v-card-actions .mg-button) {
	width: 100% !important;
}

:deep(.v-dialog .v-card-actions button) {
	width: 100% !important;
}

/* Make v-card components have rounded corners */
:deep(.v-card) {
	border-radius: 16px !important;
}

/* Make the v-text-field in the rename dialog full width */
:deep(.mg-dialog-card .v-text-field) {
  width: 100%;
}
/* Override the SwipeActionsContainer's last-child rule to ensure bottom border */
:deep(.swipe-row:last-child) {
	border-bottom: 1px solid var(--border-color) !important;
}
</style>